import ShellSessionStorageDAOImpl from '../../../dao/ShellSessionStorageDAOImpl';
import RefreshWhenAuthStatusChanged from './RefreshWhenAuthStatusChanged';
import { InitialNavigationStateRepository } from './InitialNavigationStateRepository';

const shellDAO = new ShellSessionStorageDAOImpl();
const initialNavigationStateRepository = new InitialNavigationStateRepository({
  shellDAO
});

export { initialNavigationStateRepository, RefreshWhenAuthStatusChanged };
